import React from 'react'
import { Auth, Database} from '../components/Friebase'
import { navigate } from 'gatsby'
import { fieldErrors } from './errors'
import firebase from 'firebase/app'
import { async } from 'q';

export const pattern = {
    personalNr:
      '(19|20)?[0-9]{2}[- ]?((0[0-9])|(10|11|12))[- ]?(([0-2][0-9])|(3[0-1])|(([7-8][0-9])|(6[1-9])|(9[0-1])))[- ]?[0-9]{4}',
    dateOfBirth:
      '(19|20)?[6-9]{2}[- ]?((0[0-9])|(10|11|12))[- ]?(([0-2][0-9])|(3[0-1])|(([7-8][0-9])|(6[1-9])|(9[0-1])))',
    tel: '(07)[0-9]{8}',
    email: '[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}',
    socialSecurityNumber: '[0-9]{4}[- ][- ]?((0[0-9])|(10|11|12))[- ][- ]?(([0-2][0-9])|(3[0-1])|(([7-8][0-9])|(6[1-9])|(9[0-1])))',
    postalCode: '[0-9 ]{6}',
    numeric: '[0-9]*',
    emailDomain: '[a-zA-Z0-9_\\.-]+@((hotmail)|(outlook)|(live))\\.[a-z]{2,4}'
  };
  
export const regex = {
    tel: new RegExp(`^${pattern.tel}$`),
    email: new RegExp(`^${pattern.email}$`),
    numeric: new RegExp(`^${pattern.numeric}$`),
    emailDomain: new RegExp(`^${pattern.emailDomain}$`),
};

export const checkPhoneNumber = string => {
    const check = string.match(regex.tel);
    return !!check;
};

export const checkNumeric = string => {
    const check = string.match(regex.numeric);
    return !!check;
};

export const checkEmail = string => {
    const check = string.match(regex.email);
    return !!check;
};

export const validateEmailDomain = (email) => {
    const check = email.match(regex.emailDomain);
    return !!check;
}

export const checkEmailPremium = (email, callBack) => {
    fetch(`${process.env.API_URI}/email/checkPremium`, {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json'
        },
        body: JSON.stringify({email: email})
    }).then(resp => {
        if(resp.status === 200){
            callBack(true)
        }
        else{
            callBack(false)
        }
    })
    .catch(error => console.error(error))
}

export const checkPhonePremium = (phone, callBack) => {
    fetch(`${process.env.API_URI}/phone/checkPremium`, {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json'
        },
        body: JSON.stringify({phoneNumber: phone})
    }).then(resp => resp.json())
    .then(resp => {
        if(resp){
            callBack(true)
        }
        else{
            callBack(false)
        }
    })
    .catch(error => console.error(error))
}

export const loginWithEmail = (uname, pwd, callBack) => {
    Auth.signInWithEmailAndPassword(uname, pwd)
        .then(function(user) {                
            let userId = user.user.uid;
            getUserDetails(userId, uname, pwd, (data) => {
                callBack(data)
            })
        })
        .catch(function(err) {
            callBack({status: false, data: '', error: err});
        });
}

export const loginWithPhone = (uname, pwd, callBack) => {
    fetch(`${process.env.API_URI}/phone/login`, {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json'
        },
        body: JSON.stringify({phoneNumber:uname, password:pwd})
    })
    .then(resp => resp.json())
    .then(resp => {
        if(resp){
            if (resp.customToken) {
                Auth.signInWithCustomToken(resp.customToken)
                    .then(function(user) {
                        let userId = user.user.uid;
                        getUserDetails(userId, uname, pwd, (data) => {
                            callBack(data)
                        })
                    })
                    .catch(function(ex) {
                        callBack({status: false,  error: fieldErrors.incorrectLogin})
                    });
            }
        }
        else{
            callBack({status: false,  error: fieldErrors.noUserFound})
        }
    })
    .catch(error => console.error(error))
}

export const getUserDetails = (nuid, username, pwd, callBack) => {
    if(Database != '')
    {
        Database.ref('/users/'+nuid).once('value').then(function(snap) {
            if (snap.exists()) {
                var userdata = snap.val();
                Database.ref('/userData/'+nuid).once('value').then(function(p) {
                    var ud = p.val();
                    var purchase = ud.purchases;
                    
                    var purchaseStripe = ud.purchasesStripe;
                    if( purchase !== null && userdata.premium == true && purchase.receipt && 
                        ((purchase.receipt.length !== undefined && purchase.receipt.substring(0,4) == "cus_" ) ||
                        (purchaseStripe !== undefined && purchaseStripe.receipt !== undefined && purchaseStripe.receipt.substring(0,4) == "cus_"))) 
                    {
                        let profileImg = userdata.hasOwnProperty('profilePicture') ? userdata.profilePicture : ''
                        localStorage.setItem("userDetails", JSON.stringify({uid: nuid, username: username, email: userdata.email, phone: userdata.phone, premium: userdata.premium, profilePicture: profileImg, custId: purchase.receipt, paymentType: 'stripe', password: pwd}));
                        callBack({status: true})
                    }else if( purchase !== null && userdata.premium == true) {
                        Database.ref('/userData/'+nuid+'/purchases/klarna').once('value').then(function(klarna) {
                            var us = klarna.val();

                            if( us.klarnaCustomerToken != '' && us.klarnaOrderId != '' ){
                                let profileImg = userdata.hasOwnProperty('profilePicture') ? userdata.profilePicture : ''
                                localStorage.setItem("userDetails", JSON.stringify({uid: nuid, username: username, email: userdata.email, phone: userdata.phone, premium: userdata.premium, profilePicture: profileImg, custId: us.klarnaCustomerToken, orderId: us.klarnaOrderId, paymentType: 'klarna', password: pwd}));
                                callBack({status: true})
                            }
                        })
                    }
                    else {
                        callBack({status: false, data: '', error: fieldErrors.noPurchase})
                    }
                });
            }
            else {
                callBack({status: false, data: '', error: fieldErrors.noUserFound})
            }
        });
    }
}

export const changePassword = (newPassword, callBack) => {
    if (Database !== '') {
        const user = Auth.currentUser
        const userDetails = JSON.parse(localStorage.getItem('userDetails'))
        const currentPassword = userDetails.password
        const credential = firebase.auth.EmailAuthProvider.credential(user.email, currentPassword)


        if (credential) {
            user.reauthenticateWithCredential(credential)
            .then(() => user.updatePassword(newPassword)
            .then(() => {
                let newUser = JSON.parse(localStorage.getItem('userDetails'))
                newUser.password = newPassword
                localStorage.setItem('userDetails', JSON.stringify(newUser))
                return callBack('Ditt lösenord har nu ändrats!')
            })
            .catch(e => console.error("error: ", e))
            )
        } else {
            return 'Något gick snett! Försök igen eller kontakta kundtjänst.'
        }

    }
}

export const forgotEmailPassword = (emailAddr, callBack) => {
    fetch(`${process.env.API_URI}/email/forgot-password`, {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json'
        },
        body: JSON.stringify({email: emailAddr})
    })
    .then(resp => resp.json())
    .then(resp => {
        if(resp){
            callBack({status: true , msg: fieldErrors.resetpasswordEmailSent})
        }
        else{
            callBack({status: false,  error: fieldErrors.noUserFound})
        }
    })
    .catch(error => console.error(error))
}

export const forgotPhonePassword = (phone, callBack) => {

    fetch(`${process.env.API_URI}/phone/forgot-password`, {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json'
        },
        body: JSON.stringify({phoneNumber: phone})
    })
    .then(resp => resp.json())
    .then(resp => {
        if(resp){
            callBack({status: true , msg: fieldErrors.smsSent})
        }
        else{
            callBack({status: false,  error: fieldErrors.smsNotSent})
        }
    })
    .catch(error => console.error(error))
}

export const getFirebaseUser = (uid, callBack) => {
    if(Database != '')
    {
        Database.ref('/users/'+uid).once('value').then(function(snap) {
            var userdata = snap.val();
            callBack(userdata)
        });
    }
}

export const setKlarnaSubscriptionCancel = (uid, reason, otherReson, callBack) => {
    if( Database != '')
    {
        Database.ref('/users/'+uid).update({
            cancel: {
                reason: reason,
                remark: otherReson,
                time: Date.now()
            }            
        }).then(function(snap){
            Database.ref('/userData/'+uid+'/purchases/klarna').update({
                cancelled: true
            }).then(function(snapi) {
                callBack({status: 'success', data: snapi, error: {}})
            }).catch(error => {
                console.error(error)
                callBack({status: 'error', data: {}, error: error})
            })
        })
    }
}

export const klarnaGateway = () => {
    
    const authenticate = (dataObj, callBack) => {
        const formData = {
            email: dataObj.email,
            plan: dataObj.accountType,
            price: 80,
            phone: (dataObj.hasOwnProperty('phoneNumber') ? dataObj.phoneNumber : '')
        }
        
        fetch(`${process.env.API_URI}/create/klarnaInitiate`, {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        }).then(res => res.json())
        .then(resp => {
            if(resp.status === 200)
            {
                callBack(resp.data)
            }
            else{
                callBack(false)
            }
        })
        .catch(error => console.error(error))
    }

    const order = (dataObj, callBack) => {
        const formData = {
            email: dataObj.email,
            plan: dataObj.accountType,
            price: 80,
            phone: (dataObj.hasOwnProperty('phoneNumber') ? dataObj.phoneNumber : ''),
            authToken: dataObj.authToken,
            location: 'SE',
            origin: typeof window !== 'undefined' ? window.location.href : '',
            campaign: (dataObj.hasOwnProperty('campaign') ? dataObj.campaign : 'standard'),
            days: (dataObj.hasOwnProperty('days') ? dataObj.days : 30)
        }
        fetch(`${process.env.API_URI}/create/userCreateKlarna`, {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        }).then(res => res.json())
        .then(resp => {
            callBack(resp)
        })
        .catch(res => {
            callBack(res)
        });
    }

    return {
        authenticate: authenticate,
        order: order
    };
}

export const reActivateUser = (data, callBack) => {

    fetch(`${process.env.API_URI}/reactivate/user`, {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
    .then(resp => resp.json())
    .then(resp => {
        if(resp.status === 200 || resp.status === 501 || resp.status === 401){
            callBack({status: true, data: resp})
        }
        else{
            callBack({status: false,  msg: resp.errorMsg})
        }
    })
    .catch(error => console.error(error))
}

export const isUserSubscriptionCancelled = async (customerId) => {
    const subscription = await fetch(`${process.env.API_URI}/users/subscription`, {
                                method: 'POST',
                                headers: {
                                'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({'customerId': customerId})
                            });
    let result = await subscription.json();
    return result;
}